import { EventUsers } from "../../models/events";

export const PaymentBodyTemplate = (user: EventUsers) => {
  return user.paid ? (
    <i className="pi pi-check text-primary"></i>
  ) : (
    <i className="pi pi-times" style={{ color: "red" }}></i>
  );
};
